import React from 'react';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      gap: '16px',
      flexWrap: 'wrap'
    }}>
      <div>
        {title && <h1 style={{ fontSize: '1.4rem', fontWeight: 600, color: '#1e293b', margin: 0 }}>{title}</h1>}
        {subtitle && <p style={{ fontSize: '0.875rem', color: '#64748b', margin: '4px 0 0 0' }}>{subtitle}</p>}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {actions}
        </div>
      )}
    </div>
  );
}
